// Midpoint handle — small indicator on polygon edge midpoints
// Click to insert a new vertex at this position (splitting the edge)

import * as THREE from 'three'
import type { Handle, EditableShape } from '@/types/editor'

export class MidpointHandle implements Handle {
  readonly type = 'midpoint' as const
  readonly cursor = 'copy'
  readonly mesh: THREE.Mesh

  /** Index of the first vertex of this edge */
  readonly edgeStart: number
  /** Index of the second vertex of this edge (wraps around) */
  readonly edgeEnd: number

  constructor(edgeStart: number, edgeEnd: number, mesh: THREE.Mesh, _shape: EditableShape) {
    this.edgeStart = edgeStart
    this.edgeEnd = edgeEnd
    this.mesh = mesh
  }

  // Midpoint handles are click-only — no drag behavior
  onDragStart(_worldPoint: THREE.Vector3): void {}
  onDrag(_worldPoint: THREE.Vector3, _delta: THREE.Vector3): void {}
  onDragEnd(): void {}
}
